export default __webpack_public_path__ + "static/media/new_project_logo.eb04d98d.png";